function tryOpenCookiePreferences(): boolean {
  if (typeof window.revisitCkyConsent === 'function') {
    window.revisitCkyConsent();
    return true;
  }

  const cookieyes = window.cookieyes;
  const cookieYes = window.CookieYes;

  if (typeof cookieyes?.openSettings === 'function') {
    cookieyes.openSettings();
    return true;
  }

  if (typeof cookieyes?.openPreferences === 'function') {
    cookieyes.openPreferences();
    return true;
  }

  if (typeof cookieYes?.openSettings === 'function') {
    cookieYes.openSettings();
    return true;
  }

  const preferenceCenter = document.querySelector('[data-cky-tag="detail"]');
  if (preferenceCenter) {
    preferenceCenter.classList.add('cky-modal-open');
    document.querySelector('.cky-overlay')?.classList.remove('cky-hide');
    return true;
  }

  const fallbackTrigger = document.querySelector<HTMLElement>('.cky-banner-element');
  if (fallbackTrigger) {
    fallbackTrigger.click();
    return true;
  }

  return false;
}

export function openCookiePreferences(): void {
  if (tryOpenCookiePreferences()) {
    return;
  }

  const onBannerLoad = () => {
    document.removeEventListener('cookieyes_banner_load', onBannerLoad);
    tryOpenCookiePreferences();
  };

  document.addEventListener('cookieyes_banner_load', onBannerLoad);
}
